import { ChangeDetectionStrategy, Component, input, signal } from '@angular/core';
import { IndicatorState } from '../../../models/indicator.models';
import { BadgeIndicatorComponent } from './badge-indicator.component';
import { IndicatorStates } from '../../../constants/indicators.constants';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BadgeIndicatorComponent],
  selector: 'ui-power-indicator',
  template: `
    <ui-badge-indicator
      [state]="state()"
      [value]="power()"
      [nominal]="nominal()"
      [percentage]="percentage()"
      [units]="units()"
      [unitsReference]="units()"
      [tooltipLabel]="'DISTRIBUTION_NETWORK.TABLE.POWER'"
    />
  `,
})
export class PowerIndicatorComponent {
  state = input<IndicatorState>(IndicatorStates.Default);
  power = input<number>(0);
  nominal = input<number>(0);
  percentage = input<number>(0);
  units = signal<string>('KvA');
}
